<template>
	<div class="w-40 md:w-36">
		<router-link to="/">
			<img src="@/assets/MusicNow.svg" alt="MusicNow's logo" />
		</router-link>
	</div>
</template>
